import styled from 'styled-components';

export const JobApplyListStyle = styled.div`
  .job-apply-tab-container {
    position: relative;
    .job-apply-msg {
      position: absolute;
      top: 6px;
      right: 12px;
      svg {
        width: 20px;
        height: 20px;
        path {
          fill: #1976d2;
        }
      }
    }
    @media only screen and (max-width: 768px) {
      .job-apply-msg {
        position: fixed;
        bottom: 80px;
        top: auto;
      }
    }
  }
  .apply-list-notfound {
    margin-top: 8px;
  }
  .apply-list-container {
    display: flex;
    margin-top: 8px;
    height: calc(100vh - (72px + 48px + 20px));
    > div:nth-child(1) {
      overflow-y: auto;
      width: 40%;
    }
    > div:nth-child(3) {
      width: 60%;
      padding: 0 12px;
      overflow-y: auto;
      height: calc(100vh - (72px + 48px + 20px));
    }
    @media only screen and (max-width: 768px) {
      > div:nth-child(1) {
        overflow-y: auto;
        width: 100%;
      }
    }
  }
  .pagination-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    height: 35px;
    padding-top: 4px;
    background-color: ${({ theme }) => theme.Bg1};
  }
  .apply-list-doc {
    #DocContainer {
      margin: 0px auto;
      border-radius: 4px;
      margin-bottom: 20px;
      min-height: auto;
      border: none;
      box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
        rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    }
    .react-pdf__Page__canvas {
      width: 100% !important;
    }
    .job-attachment-container {
      background-color: ${({ theme }) => theme.lightGray};
      border-radius: 4px;
      padding: 4px 2px 1px 2px;
      margin-bottom: 20px;
    }
  }
  .profile-img {
    width: 55px;
    height: 55px;
    margin-right: 8px;
    border-radius: 50%;
  }
  .user-name {
    font-size: 14px;
    font-weight: 500;
    color: #828282;
  }
  .apply-list-item {
    display: flex;
    position: relative;
  }
  .apply-list-item-container {
    cursor: pointer;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.border1};
    border-top: none;
    padding: 8px;
    &:hover {
      background-color: ${({ theme }) => theme.Bg1};
    }
  }
  .apply-list-bg {
    background-color: ${({ theme }) => theme.Bg1};
  }
  .apply-list-item-content {
    display: flex;
    align-items: flex-start;
    font-size: 15px;
  }
  .apply-list-item-text {
    margin-top: 4px;
  }
  .apply-list-skills {
    margin-top: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .apply-list-experience {
    font-size: 14px;
    margin-top: 4px;
  }
  .apply-title {
    font-size: 16px;
    font-weight: 700;
    margin-top: 16px;
  }
  .apply-title-resume {
    font-size: 16px;
    font-weight: 700;
    margin: 8px 0 20px 6px;
  }
  .apply-label-value-container {
    width: 100%;
    tr {
      display: flex;
      font-size: 15px;
      border-bottom: none;

      > td:nth-child(1),
      > td:nth-child(2) {
        overflow: hidden;
        text-overflow: ellipsis;
      }

      > td:nth-child(1) {
        padding: 8px 15px 8px 0;
        width: 18%;
        font-weight: 500;
      }

      > td:nth-child(2) {
        padding: 8px 15px 8px 0;
        width: 80%;
      }

      @media only screen and (max-width: 768px) {
        flex-direction: column;

        > td:nth-child(1),
        > td:nth-child(2) {
          width: 100%;
        }

        > td:nth-child(1) {
          font-size: 14px;
          padding: 12px 0 4px 0;
          color: ${({ theme }) => theme.fieldText1};
        }
        > td:nth-child(2) {
          padding: 0;
        }
      }
    }
    .job-list-skill {
      > div {
        min-height: 24px;
        height: auto;
        padding: 2px;
        font-size: 15px;
        margin-right: 4px;
        margin-bottom: 4px;
      }
    }
    .MuiChip-label {
      white-space: break-spaces;
    }
  }
  .apply-action {
    margin-top: 0px;
    display: flex;
    justify-content: flex-end;
    button {
      height: 26px;
      font-size: 13px;
      margin-left: 8px;
    }
  }
  .no-data-found {
    width: 100%;
    height: calc(100vh - (72px + 48px + 20px));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #c4c4c4;
    font-weight: 600;
    font-size: 20px;
    padding: 0;
    svg {
      width: 130px;
      height: 130px;
      margin-bottom: 10px;
    }
  }
`;

export const ManageMessageModel = styled.div`
  .message-notes {
    font-size: 14px;
    color: #696969;
    margin-bottom: 16px;
  }
`;
